import type { DeepPartial } from '@luna/utils-ts';

import type { Print } from '../../types/Print';

export const printHUFeatureConfig: DeepPartial<Print> = {
    showAccountInfo: true,
    showInfoFilter: true,
    showSettlementAccount: true,
};
